import CoreSpinner from '@ergeon/core-components/exports/Spinner.ts';

export const Spinner = ({ size = 32 }: { size?: number }) => <CoreSpinner active color="blue" size={size} />;
